import { mapActions, mapGetters } from 'vuex';

export default {
    computed: {
        ...mapGetters([
            'tutorials',
        ]),
        defaultStepOptions() {
            return {
                buttons: [
                    {
                        action() {
                            return this.back();
                        },
                        classes: 'previous',
                        text: this.$t('tourGuide.previous'),
                    },
                    {
                        action() {
                            return this.next();
                        },
                        classes: 'next',
                        text: this.$t('tourGuide.next'),
                    },
                ],
            };
        },
    },
    methods: {
        ...mapActions([
            'turnOffTutorial',
        ]),
    },
};
